import React, { useEffect, useState } from "react";
import CommonBreadcrumb from "./../../common_components/breadcrumb/CommonBreadcrumb";
import "./Wallet_History.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import View_Single_Wallet_History from "./view_single_wallet_history/View_Single_Wallet_History";
import { getUserWalletHistory } from "../../../features/admin/auth/Slice";
import { useDispatch, useSelector } from "react-redux";

const Wallet_History = () => {
  const breadcrumbItems = [
    { label: "Profile", link: "/profile" },
    { label: "Wallet History" },
  ];

  const dispatch = useDispatch();
  const userWalletHistory = useSelector(
    (state) => state?.auth?.login?.getUserWalletHistoryData?.data,
  );

  const [showModal, setShowModal] = useState(false);
  const [selectedWalletId, setSelectedWalletId] = useState(null);

  useEffect(() => {
    dispatch(getUserWalletHistory());
  }, [dispatch]);

  // Handle click on eye icon
  const handleViewClick = (id) => {
    setSelectedWalletId(id);
    setShowModal(true);
  };

  return (
    <section className="order-plased-section order-history Wallet_History history-table-section">
      <CommonBreadcrumb items={breadcrumbItems} />

      <div className="container">
        <div className="history_div">
          <div className="table-responsive">
            <table className="payout-table">
              <thead>
                <tr className="table-heading">
                  <th>Sr. No.</th>
                  <th>Year</th>
                  <th>Total Income</th>
                  <th>Total Reward</th>
                  <th>Total Paid</th>
                  <th>Total Due</th>
                  <th>Payment Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {userWalletHistory && userWalletHistory.length > 0 ? (
                  userWalletHistory.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>{item.year}</td>
                      <td>₹{Number(item.total_income).toLocaleString()}</td>
                      <td>₹{Number(item.reward).toLocaleString()}</td>
                      <td>₹{Number(item.total_paid).toLocaleString()}</td>
                      <td>₹{Number(item.total_due).toLocaleString()}</td>
                      <td>{item.status}</td>
                      <td>
                        <div className="icon_holder">
                          <FontAwesomeIcon
                            icon={faEye}
                            className="eye_icon"
                            onClick={() => handleViewClick(item.id)}
                          />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No Data
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Pass the selectedWalletId to the modal */}
      <View_Single_Wallet_History
        show={showModal}
        handleClose={() => setShowModal(false)}
        walletId={selectedWalletId} // pass the ID
      />
    </section>
  );
};

export default Wallet_History;
